import * as React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import {
  ButtonGroup,
  IconButton,
  Hero,
  Subtitle,
  Title,
  RouteWrapper,
} from '../../components';
import { removeReservation } from '../../redux/actions/reservations';

interface Props {
  match: any;
  handleRemoveReservation: Function;
}

const Route = ({ match, handleRemoveReservation }: Props) => (
  <RouteWrapper
    title="Remove Reservation"
    requireAuth
    requirePermission="MANAGE_RESERVATIONS"
  >
    <Hero className="is-danger is-fullheight has-text-centered">
      <Title large>Remove Reservation?</Title>
      <Subtitle>
        Once this reservation is removed, you will not be able to view it
        anymore.
      </Subtitle>
      <ButtonGroup>
        <IconButton
          className="button is-danger is-large is-outlined is-inverted"
          handleClick={() => {
            handleRemoveReservation(match.params.id);
          }}
          icon="trash"
          large
        >
          Remove Reservation
        </IconButton>
        <IconButton
          className="button is-danger is-outlined is-large is-inverted"
          link={`/reservations/${match.params.id}`}
          icon="undo"
          large
        >
          Cancel
        </IconButton>
      </ButtonGroup>
    </Hero>
  </RouteWrapper>
);

const mapDispatchToProps = (dispatch) => ({
  handleRemoveReservation: (id) => {
    dispatch(removeReservation(id)).then((response) => {
      if (!response.error) {
        dispatch(goBack());
        dispatch(goBack());
      } else {
        dispatch(goBack());
      }
    });
  },
});

export default connect(() => ({}), mapDispatchToProps)(Route);
